import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQ } from "../../content";
import { Reveal, Eyebrow } from "./Reveal";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow color="var(--grape)"><span className="text-white">FAQ</span></Eyebrow>
        <h2 className="font-display font-bold text-4xl sm:text-5xl mt-6 leading-[0.95]">Good questions.</h2>
        <p className="font-hand text-2xl mt-4 text-[var(--ink-soft)]">(we asked our parents too)</p>
      </Reveal>
      <Reveal className="lg:col-span-8" delay={0.1}>
        <Accordion type="single" collapsible className="space-y-4">
          {FAQ.map((f, i) => (
            <AccordionItem key={f.q} value={`q${i}`} className="sticker-sm rounded-2xl bg-white px-6 border-b-[2.5px]">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-display font-semibold text-lg sm:text-xl text-left hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-[var(--ink-soft)] leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
